import { render } from "./addFriendly.vue?vue&type=template&id=d523dec8"
import script from "./addFriendly.vue?vue&type=script&lang=js"
export * from "./addFriendly.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__